import React from 'react'
import { Link as RouterLink } from 'react-router-dom'
import { Box, Button, Divider, Paper, Typography } from '@mui/material'
import ROUTES from '../../../routesConfig'
import MarketingPageLayout from './MarketingPageLayout'

const HowItWorksPage = () => {
  return (
    <MarketingPageLayout>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3.5 }}>
        <Box>
          <Typography variant="h4" component="h1" sx={{ fontWeight: 800, mb: 1 }}>
            Anear: Play Together, In Person
          </Typography>
          <Typography variant="body1" sx={{ lineHeight: 1.65, color: 'rgba(230,233,239,0.9)' }}>
            Anear is a platform for face-to-face group experiences—games, polls, trivia, Q&amp;A, and interactive moments that bring
            people together, whether you know them or not.
          </Typography>
          <Typography variant="body1" sx={{ mt: 1.25, lineHeight: 1.65, color: 'rgba(230,233,239,0.9)' }}>
            There's no app to install and no accounts required to start. Just scan a QR code and join. One person can invite strangers nearby, and the experience spreads across the room as more people join.
          </Typography>
        </Box>

        <Paper
          elevation={0}
          sx={{
            bgcolor: 'rgba(255,255,255,0.06)',
            border: '1px solid rgba(255,255,255,0.1)',
            borderRadius: 2,
            p: 2.5,
          }}
        >
          <Typography variant="h6" component="h2" sx={{ fontWeight: 700, mb: 1.5 }}>
            How It Works
          </Typography>

          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
            <Box>
              <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
                1. Someone starts an Anear event
              </Typography>
              <Typography variant="body1" sx={{ color: 'rgba(230,233,239,0.9)', lineHeight: 1.6 }}>
                A host creates an experience—like trivia, a poll, or a group activity—and displays a QR code on a phone, tablet,
                or screen.
              </Typography>
            </Box>

            <Box>
              <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
                2. Guests scan to watch or join
              </Typography>
              <Typography variant="body1" sx={{ color: 'rgba(230,233,239,0.9)', lineHeight: 1.6 }}>
                Anyone nearby—friends or strangers—scans the QR code and instantly sees what's happening. They can watch as a spectator or tap "Join"
                to participate. The QR code spreads naturally as people share it with others nearby.
              </Typography>
            </Box>

            <Box>
              <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
                3. Everyone plays together, live
              </Typography>
              <Typography variant="body1" sx={{ color: 'rgba(230,233,239,0.9)', lineHeight: 1.6 }}>
                Players interact in real time on their own phones while staying fully engaged with the people around them. Anear
                is designed to enhance real-world interaction, not replace it.
              </Typography>
            </Box>
          </Box>
        </Paper>

        <Box>
          <Typography variant="h6" component="h2" sx={{ fontWeight: 700, mb: 1 }}>
            Why Anear Is Different
          </Typography>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.75 }}>
            <Typography variant="body1" sx={{ color: 'rgba(230,233,239,0.9)' }}>
              - Location-aware &amp; in-person — connects strangers and friends at the same event or venue
            </Typography>
            <Typography variant="body1" sx={{ color: 'rgba(230,233,239,0.9)' }}>
              - Phone-first — no downloads, no friction
            </Typography>
            <Typography variant="body1" sx={{ color: 'rgba(230,233,239,0.9)' }}>
              - Live &amp; social — perfect for shared moments
            </Typography>
            <Typography variant="body1" sx={{ color: 'rgba(230,233,239,0.9)' }}>
              - Flexible experiences — games, polls, Q&amp;A, icebreakers, and more
            </Typography>
          </Box>
          <Typography variant="body1" sx={{ mt: 1.25, color: 'rgba(230,233,239,0.9)', lineHeight: 1.65 }}>
            Anear works best when people are laughing, talking, and looking up from their screens.
          </Typography>
        </Box>

        <Box>
          <Divider sx={{ borderColor: 'rgba(255,255,255,0.1)', mb: 1.5 }} />
          <Box sx={{ display: 'flex', gap: 1.25, flexWrap: 'wrap' }}>
            <Button
              component={RouterLink}
              to={ROUTES.APPS}
              variant="contained"
              color="primary"
              sx={{ fontWeight: 700 }}
            >
              Explore apps
            </Button>
            <Button
              component={RouterLink}
              to={ROUTES.ABOUT}
              variant="outlined"
              sx={{ fontWeight: 700, color: '#E6E9EF', borderColor: 'rgba(255,255,255,0.25)' }}
            >
              About
            </Button>
          </Box>
        </Box>
      </Box>
    </MarketingPageLayout>
  )
}

export default HowItWorksPage


